module.exports = "/_next/static/images/AutomaticallyMeasure@2x-b28cdf33d7cc4b2a83357f122ddeb106.png";